import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api"; // 👈 Ab hum apna banaya hua API use karenge
import Swal from "sweetalert2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "../styles/auth.css";

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const submit = async (e) => {
    e.preventDefault();

    try {
      // Form se data nikalna
      const email = e.target.email.value;
      const password = e.target.password.value;

      const res = await API.post("/auth/login", { email, password });

      // ✅ Token ko browser mein save karna
      if (res.data.token) {
        localStorage.setItem("token", res.data.token);

        Swal.fire({
          icon: "success",
          title: "Login Successful",
          timer: 1200,
          showConfirmButton: false,
          background: '#0f172a',
          color: '#fff'
        });

        // 1.2 second baad dashboard par bhejna
        setTimeout(() => navigate("/dashboard"), 1200);
      }
    } catch (err) {
      const msg = err.response?.data?.message || "Invalid Email or Password";
      Swal.fire("Error", msg, "error");
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h3 className="auth-title">Admin Login</h3>
        <form onSubmit={submit}>
          <div className="form-group">
            <input className="form-control" type="email" name="email" placeholder="Email Address" required />
          </div>

          <div className="form-group password-wrapper">
            <input
              className="form-control"
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Password"
              required
            />
            <span className="eye-btn" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </span>
          </div>

          <button className="btn auth-btn">LOGIN</button>
        </form>

        <button className="switch-btn" onClick={() => navigate("/register")}>
          <h2>New Admin? Register</h2>
        </button>
      </div>
    </div>
  );
}
